import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  generateQuiz: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/quiz-generator`,
  },
  generateSlide: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/generate-slide`,
  },
  requestMoreQuiz: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/request-more-quiz`,
  },
  getExamples: {
    method: 'GET',
    url: `${configs.baseUrl}/api/openai/get-examples`,
  },
  generateTemplateDescription: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/generate-template-description`,
  },
  sendFeedbackOnDocumentQuizzes: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/document-quizzes/feedback`,
  },
  sendFeedbackOnSlidesGeneratorResult: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/generate-slide/feedback`,
  },
  groupOpenEndedAnswers: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/group-open-ended/{slideId}`,
  },
  stressTestOpenEndedAnswers: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/group-open-ended-stress-test/{slideId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// AI SLIDES GENERATOR
const generateQuiz = async (params) => {
  const res = await resource.generateQuiz(params)
  return res.body
}

const generateSlide = async (params) => {
  const res = await resource.generateSlide(params)
  return res.body
}

const getExamples = async () => {
  const res = await resource.getExamples()
  return res.body
}

// DOC TO QUIZ
const requestMoreQuiz = async (params) => {
  const res = await resource.requestMoreQuiz(params)
  return res.body
}

const sendFeedbackOnDocumentQuizzes = async (params) => {
  const res = await resource.sendFeedbackOnDocumentQuizzes(params)
  return res.body
}

// TEMPLATE DESCRIPTION
const generateTemplateDescription = async (params) => {
  const res = await resource.generateTemplateDescription(params)
  return res.body
}

// GROUP OPEN ENDED ANSWERS
const groupOpenEndedAnswers = async (slideId, params) => {
  await resource.groupOpenEndedAnswers({ slideId }, params)
}

const stressTestOpenEndedAnswers = async (payload) => {
  const { slideId } = payload
  await resource.stressTestOpenEndedAnswers({ slideId }, payload)
}

const sendFeedbackOnSlidesGeneratorResult = async (params) => {
  const res = await resource.sendFeedbackOnSlidesGeneratorResult(params)
  return res.body
}

export default {
  initResource,

  // AI SLIDES GENERATOR
  generateQuiz,
  generateSlide,
  getExamples,

  // DOC TO QUIZ
  requestMoreQuiz,
  sendFeedbackOnDocumentQuizzes,
  sendFeedbackOnSlidesGeneratorResult,

  // TEMPLATE DESCRIPTION
  generateTemplateDescription,

  // GROUP OPEN ENDED ANSWERS
  groupOpenEndedAnswers,
  stressTestOpenEndedAnswers,
}
